/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ContainerCreateResponse } from '../models/container-create-response';
import { ContainerDetailedResponse } from '../models/container-detailed-response';
import { createContainer } from '../fn/containers/create-container';
import { CreateContainer$Params } from '../fn/containers/create-container';
import { getContainer } from '../fn/containers/get-container';
import { GetContainer$Params } from '../fn/containers/get-container';
import { getContainers } from '../fn/containers/get-containers';
import { GetContainers$Params } from '../fn/containers/get-containers';
import { getContainersForAdmin } from '../fn/containers/get-containers-for-admin';
import { GetContainersForAdmin$Params } from '../fn/containers/get-containers-for-admin';
import { PageContainerAdminPageResponse } from '../models/page-container-admin-page-response';
import { PageContainerPageResponse } from '../models/page-container-page-response';
import { updateContainer } from '../fn/containers/update-container';
import { UpdateContainer$Params } from '../fn/containers/update-container';
import { updateContainerStatus } from '../fn/containers/update-container-status';
import { UpdateContainerStatus$Params } from '../fn/containers/update-container-status';


/**
 * Container resource endpoints. GET /containers is accessible to all authenticated users. Other operations require PRODUCT_ADMIN or EASYLOT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ContainersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getContainer()` */
  static readonly GetContainerPath = '/containers/{containerId}';

  /**
   * Gets container.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContainer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainer$Response(params: GetContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerDetailedResponse>> {
    const obs = getContainer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets container.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContainer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainer(params: GetContainer$Params, context?: HttpContext): Observable<ContainerDetailedResponse> {
    const resp = this.getContainer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ContainerDetailedResponse>): ContainerDetailedResponse => r.body)
    );
  }

  /** Path part for operation `updateContainer()` */
  static readonly UpdateContainerPath = '/containers/{containerId}';

  /**
   * Updates a container.
   *
   * Updates an existing container based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContainer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContainer$Response(params: UpdateContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateContainer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a container.
   *
   * Updates an existing container based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContainer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContainer(params: UpdateContainer$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateContainer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateContainerStatus()` */
  static readonly UpdateContainerStatusPath = '/admin/containers/status';

  /**
   * Updates the status of containers by admin.
   *
   * Updates the status of containers based on the provided list of container ids and a status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContainerStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContainerStatus$Response(params: UpdateContainerStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateContainerStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the status of containers by admin.
   *
   * Updates the status of containers based on the provided list of container ids and a status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContainerStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContainerStatus(params: UpdateContainerStatus$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateContainerStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getContainers()` */
  static readonly GetContainersPath = '/containers';

  /**
   * Gets containers.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContainers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainers$Response(params: GetContainers$Params, context?: HttpContext): Observable<StrictHttpResponse<PageContainerPageResponse>> {
    const obs = getContainers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets containers.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContainers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainers(params: GetContainers$Params, context?: HttpContext): Observable<PageContainerPageResponse> {
    const resp = this.getContainers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageContainerPageResponse>): PageContainerPageResponse => r.body)
    );
  }

  /** Path part for operation `createContainer()` */
  static readonly CreateContainerPath = '/containers';

  /**
   * Creates a new container.
   *
   * Creates a new container and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createContainer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContainer$Response(params: CreateContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerCreateResponse>> {
    const obs = createContainer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new container.
   *
   * Creates a new container and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createContainer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContainer(params: CreateContainer$Params, context?: HttpContext): Observable<ContainerCreateResponse> {
    const resp = this.createContainer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ContainerCreateResponse>): ContainerCreateResponse => r.body)
    );
  }

  /** Path part for operation `getContainersForAdmin()` */
  static readonly GetContainersForAdminPath = '/admin/containers';

  /**
   * Gets containers for admin.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContainersForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainersForAdmin$Response(params?: GetContainersForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<PageContainerAdminPageResponse>> {
    const obs = getContainersForAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets containers for admin.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContainersForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainersForAdmin(params?: GetContainersForAdmin$Params, context?: HttpContext): Observable<PageContainerAdminPageResponse> {
    const resp = this.getContainersForAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageContainerAdminPageResponse>): PageContainerAdminPageResponse => r.body)
    );
  }

}
